import { useEffect, useRef } from 'react'

export function useEffectOnceWithCondition<T extends Array<unknown>>(
  callback: (dependencies: T) => void,
  condition: (dependencies: T) => boolean,
  dependencies: T,
): void {
  const calledOnce = useRef<boolean>(false)

  useEffect(() => {
    if (calledOnce.current) {
      return
    }

    if (condition(dependencies)) {
      callback(dependencies)

      calledOnce.current = true
    }
  }, [callback, condition, dependencies])
}
